/**
 * Central configuration for HTML5 and Vimeo video embeds on the site.
 * Used to disable playback entirely or narrow down Safari issues by section.
 * Exports:
 * - DISABLE_ALL_VIDEO_EMBEDS: When true, no video markup or Vimeo logic runs.
 * - VIDEO_EMBED_SECTION_ENABLED: Per-area gates; only read when the master flag is false.
 * - shouldRenderVideoEmbed: Whether a given section may render its embed.
 *   @param {'marqueeBackground'|'dontMissOut'|'thisIsYourMoment'|'videoPage'} section - Embed area key.
 *   @returns {boolean} True if that section should render its video or Vimeo UI.
 */

/**
 * Master kill-switch: set `true` to omit every video embed (and Vimeo script) site-wide.
 * Set back to `false` once Safari bisect is done so production shows video again.
 */
export const DISABLE_ALL_VIDEO_EMBEDS = false;

/**
 * When DISABLE_ALL_VIDEO_EMBEDS is false, each flag controls that area only.
 * Set all but one to false to bisect which embed breaks desktop Safari.
 */
export const VIDEO_EMBED_SECTION_ENABLED = {
    marqueeBackground: true,
    dontMissOut: true,
    thisIsYourMoment: true,
    videoPage: true,
};

/**
 * @param {'marqueeBackground'|'dontMissOut'|'thisIsYourMoment'|'videoPage'} section
 * @returns {boolean}
 */
export function shouldRenderVideoEmbed(section) {
    if (DISABLE_ALL_VIDEO_EMBEDS) {
        return false;
    }
    return Boolean(VIDEO_EMBED_SECTION_ENABLED[section]);
}
